var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tito-block-alert tito-alert-light-warning",attrs:{"role":"alert"}},[_c('font-awesome-icon',{staticClass:"text-warning",attrs:{"icon":['fas', 'exclamation-triangle']}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(
      _vm.$t('views.registrations._form.email_not_authorized', _vm.locale, {
        href: `mailto:${_vm.contactEmail}`,
      })
    )}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }